<template>
<confirm-base @showErrorModal="$emit('showErrorModal', $event)" @showLoginModal="$emit('showLoginModal', $event)">
  <template scope="prop">
    <div class="form-group p-3">
      <label for="SchoolTitle" co-3>教室名・タイトル（コース名）<span class="attention">※</span></label>
      <p class="font-weight-bold">{{ prop.item.event_name }}</p>
    </div>
    <div class="form-group p-3">
      <label for="SchoolTeacher">講師名（活動名）<span class="attention">※</span></label>
      <p class="font-weight-bold">{{ prop.item.lecturer_name }}先生</p>
    </div>
    <div class="form-group p-3">
      <label for="Day" class="col-form-label">開催日</label>
      <pre class="font-weight-bold">{{ prop.item.event_date }}</pre>
    </div>
    <div class="form-group p-3">
      <label for="Event-date-public-input" class="col-form-label">開催日(一覧表示用)<span class="attention">※</span></label>
      <p v-if="prop.item.event_date_public" class="font-weight-bold">{{ prop.item.event_date_public }}</p>
      <pre v-else class="font-weight-bold">{{ prop.item.event_date_public_multi }}</pre>
      <pre v-if="!prop.item.event_date_public" class="font-weight-bold">開催日の23:59まで掲載されます。</pre>
    </div>
    <div v-if="prop.item.event_date_public" class="form-group p-3">
      <label for="School-dateEnd-input" class="col-form-label">掲載終了日<span class="attention">※</span></label>
      <p class="font-weight-bold">{{ prop.endDate }}</p>
    </div>
    <div class="form-group p-3">
      <p for="SchoolPlace">開催場所・住所<span class="attention">※</span></p>
      <p class="font-weight-bold">{{ prop.fullAddress }}</p>
    </div>
    <div class="form-group p-3">
      <label for="SchoolTel">問い合わせ先電話番号</label>
      <p class="font-weight-bold">{{ prop.item.inquiry.tel }}</p>
    </div>
    <div class="form-group p-3">
      <label for="SchoolMail">問い合わせ先メールアドレス<span class="attention">※</span></label>
      <p class="font-weight-bold">{{ prop.item.inquiry.email }}</p>
    </div>
    <div class="form-group p-3">
      <label for="School">会場名<span class="attention">※</span></label>
      <p class="font-weight-bold">{{ prop.item.venue.venue_name }}</p>
    </div>
    <div class="form-group p-3">
      <label for="SchoolURL">会場ホームページ（アクセス方法）</label>
      <p class="font-weight-bold">{{ prop.item.venue.homepage }}</p>
    </div>
    <div class="form-group p-3">
      <label for="SchoolBlog">講師ホームページ・ブログ記事URL</label>
      <pre class="font-weight-bold">{{ prop.item.lecturer_url }}</pre>
    </div>
    <div class="form-group p-3">
      <label for="SchoolDes">撮影会詳細</label>
      <pre class="font-weight-bold">{{ prop.item.description }}</pre>
    </div>
    <div class="form-group p-3">
      <label for="SchoolPrice">参加費</label>
      <div class="input-group">
        <pre class="font-weight-bold">{{ prop.item.fee }}</pre>
      </div>
    </div>
    <div class="form-group p-3">
      <label for="AppURL">お申し込みURL</label>
      <p class="font-weight-bold">{{ prop.item.entry_url }}</p>
    </div>
    <div class="form-group p-3">
      <label for="SchoolParking">駐車場有無</label>
      <p class="font-weight-bold">{{ prop.item.parking }}</p>
    </div>
    <div class="form-group p-3">
      <label for="SchoolImage">画像</label>
      <div class="row">
        <image-item v-for="f in prop.item.images.filter(i => i !== '')" :key="f" :image="f"/>
      </div>
    </div>
    <div class="form-group p-3">
      <label for="Schoolpublic">公開設定<span class="attention">※</span></label>
      <p class="font-weight-bold">{{ prop.item.published }}</p>
    </div>
  </template>
</confirm-base>
</template>

<script>
import ConfirmBase from '../ConfirmBase.vue'
import ImageItem from 'components/lecturer/ImageItem'
export default {
  components: {
    ConfirmBase,
    ImageItem
  }
}
</script>



// WEBPACK FOOTER //
// SchoolConfirm.vue?63b26042